

































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  UserDetail,
  RoleInInstitution,
  ZuzhijiagouList,
  SearchUsers,
  AddComposeUser,
} from "@/request/yonghuquanxian";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class ZhglCompose extends Vue {
  private institution: any = {};
  private institutions: any[] = [];
  private user: any = { role_id: "" };
  private account: any = {};
  private accounts: any = {};
  private ifShowAccountSearch: boolean = false;
  private searchAccountText: any = "";
  private roles: any[] = [];
  /**
   * @description 获取用户详情
   */
  private getUserDetail() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          user_id: this.user.user_id,
        },
      };
      UserDetail(this, params)
        .then((data: any) => {
          this.user = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获得可选的组织结构列表
   */
  private getZuzhijiagouList(text) {
    const params: any = {
      params: {
        search: text,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      this.institutions = data;
    });
  }
  /**
   * @description 获得机构和角色的关系
   */
  private getRoleInInstitution(id) {
    return new Promise((resolve, reject) => {
      if (!id) {
        resolve();
        return;
      }
      const params: any = {
        params: {
          institution_id: id,
        },
      };
      RoleInInstitution(this, params)
        .then((data: any) => {
          this.roles = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 打开搜索账号弹窗
   */
  private openSearchAccount() {
    this.ifShowAccountSearch = true;
    this.$nextTick().then(() => {
      (this.$refs["searchAccountSelect"] as any).focus();
      this.$nextTick().then(() => {
        this.searchAccountText = this.user["用户名"];
      });
    });
    // this.getAccount(this.searchAccountText);
  }
  /**
   * @description 获得账号
   */
  private getAccount(text) {
    const params: any = {
      params: {
        search: text,
      },
    };
    SearchUsers(this, params).then((data: any) => {
      this.accounts = data;
    });
  }
  /**
   * @description 选择一个已有账号
   */
  private selectAccount(e) {
    this.user = e;
    this.ifShowAccountSearch = false;
  }
  /**F
   * @description 保存
   */
  private save() {
    if (this.user["姓名"] === "admin") {
      this.$message.warning("对不起，不能编辑超级管理员账号");
      return;
    }
    if (this.user["用户名"].length > 18) {
      this.$message.warning("账户名太长，请输入18个字符以内的账户名");
      return;
    }
    if (!this.user.institution_id) {
      this.$message.warning("所属层级必须选择");
      return;
    }
    if (!this.user["用户名"]) {
      this.$message.warning("请填写账户名");
      return;
    }
    if (!this.user["姓名"]) {
      this.$message.warning("请填写姓名");
      return;
    }
    if (!this.user["性别"]) {
      this.$message.warning("请选择性别");
      return;
    }
    if (!this.user["手机号"]) {
      this.$message.warning("请填写手机号");
      return;
    }
    if (this.user["手机号"].length !== 11) {
      this.$message.warning("手机号长度不正确");
      return;
    }
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.user["手机号"])) {
      this.$message.warning("手机号格式不正确");
      return;
    }
    if (!this.user.role_id) {
      this.$message.warning("角色必须选择");
      return;
    }
    if (!this.user["状态"]) {
      this.$message.warning("状态必须选择");
      return;
    }
    AddComposeUser(this, this.user).then((data: any) => {
      this.$message.success("新增成功");
      this.$router.back();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getZuzhijiagouList(" ");
    if (this.$route.query.id) {
      this.user["user_id"] = this.$route.query.id;
      this.getUserDetail().then(() => {
        this.user["institution_id"] = this.$route.query.insId;
        this.getRoleInInstitution(this.user["institution_id"]).then(() => {
          this.$set(this.user, "role_id", this.$route.query.role_id);
        });
      });
    }
  }
}
